import React from 'react';
import { useLanguageLocale } from '../../../../hooks/language-locale-hooks';
import { LocationsDropdownToolbar } from '../../../../components/LocationsDropdownToolbar/LocationsDropdownToolbar';
import { ContentContainer } from '../../../../components/ContentContainer';
import { isRecordFound, useSingleLocationRedirect, useSelectedOrganizationData } from '../../../../hooks/data-hooks';
import { TimelineEvents } from '../../../../components/TimelineEvents';
import { PopupProvider } from '../../../../data/DataProviders/TimelinePopupProvider';

export const TimelineOrganizationEvents: React.FC = () => {
    const [disableDownload,setdisableDownload] = React.useState<boolean>(false);
    const { t } = useLanguageLocale();
    const selectedOrganizationData = useSelectedOrganizationData();
    useSingleLocationRedirect();
    
    const isDisableDownload = (value: boolean): void => {
        setdisableDownload(value);
    }



    return (
        <>
            <PopupProvider>
                <LocationsDropdownToolbar title={t('DASHBOARD.TIMELINE_TITLE')} disableDownload={disableDownload}/>

                <ContentContainer testId="organization-timeline-page">
                    {isRecordFound(selectedOrganizationData) && (
                        <TimelineEvents
                            showPath
                            appRoute={{
                                type: 'TimelineOrganizationEventDetails',
                                alarmId: '--',
                                deviceId: '--',
                            }}
                            disableDownload ={isDisableDownload}
                        />
                    )}
                </ContentContainer>
            </PopupProvider>
        </>
    );
};
